<template>
  <div class="ma-6">
    <div class="maxh-4">
      <p>Clique no botão abaixo para desativar esta câmera.</p>
      <p>A câmera não será removida, apenas oculta da lista.</p>
      <p>
        Se a câmera está ligada, ela continuará transmitindo informações
        para o veículo associado. Para impedir isto, primeiro desassocie
        a câmera do veículo.
      </p>
      <OHoldToConfirm
        class="my-4"
        :large="true"
        color="error"
        label="Desativar"
        @confirmed="doDeactivate"
      />
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'
import OHoldToConfirm from 'oderon-vue/cpts/OHoldToConfirm.vue'

export default {
  tabTitle: 'Desativar',
  components: { OHoldToConfirm },
  methods: {
    async doDeactivate() {
      await EditStore.deactivate()
      this.$snack('Desativada com sucesso')

    }
  }
}
</script>

<style></style>
